<template>
  <div class="adm-form" v-if="actionTournamentAddCategory">
    <div class="adm-form-head">
      <div>
        <span class="adm-form-kicker"><tkd-icon name="belt"/> Категорія</span>
        <h4 class="adm-form-title">{{ formAddCategory.id ? 'Редагувати категорію' : 'Нова категорія' }}</h4>
      </div>
      <button type="button" class="adm-form-close" @click="saveCategoryClose()" title="Закрити" aria-label="Закрити"><tkd-icon name="close"/></button>
    </div>

    <div class="adm-form-body">
      <section class="adm-section">
        <h5 class="adm-section-title"><tkd-icon name="notes"/> Основне</h5>
        <div class="adm-form-grid">
          <div class="adm-field adm-span-all" :class="{ 'has-error': errors.name }">
            <label class="adm-label" for="cat-name">Назва категорії <span class="adm-req">*</span></label>
            <input id="cat-name" class="adm-input" type="text" v-model="formAddCategory.name" placeholder="Наприклад: Юнаки 12-14 років -45кг" @input="clearError('name')">
            <div class="adm-field-error" v-if="errors.name">{{ errors.name }}</div>
          </div>

          <div class="adm-field adm-span-2">
            <label class="adm-label" for="cat-age">Вікова категорія</label>
            <input id="cat-age" class="adm-input" type="text" v-model="formAddCategory.agecategory" list="cat-age-list" placeholder="Наприклад: Юнаки">
            <datalist id="cat-age-list">
              <option v-for="value in ageCategorySuggestions" :key="value" :value="value"></option>
            </datalist>
          </div>

          <div class="adm-field adm-span-2">
            <label class="adm-label">Стать</label>
            <div class="adm-choice" role="radiogroup" aria-label="Стать">
              <button v-for="option in options.sex" :key="option.id" type="button" role="radio"
                      :aria-checked="isChosen(formAddCategory.sex, option.id) ? 'true' : 'false'"
                      :class="{ active: isChosen(formAddCategory.sex, option.id) }"
                      @click="formAddCategory.sex = option">{{ option.name }}</button>
            </div>
          </div>

          <div class="adm-field adm-span-2" :class="{ 'has-error': errors.categoryStatus }">
            <label class="adm-label">Статус <span class="adm-req">*</span></label>
            <div class="adm-choice" role="radiogroup" aria-label="Статус">
              <button v-for="option in options.status" :key="option.id" type="button" role="radio"
                      :aria-checked="isChosen(formAddCategory.categoryStatus, option.id) ? 'true' : 'false'"
                      :class="{ active: isChosen(formAddCategory.categoryStatus, option.id) }"
                      @click="choose('categoryStatus', option)">{{ option.name }}</button>
            </div>
            <div class="adm-field-error" v-if="errors.categoryStatus">{{ errors.categoryStatus }}</div>
          </div>
        </div>
      </section>

      <section class="adm-section">
        <h5 class="adm-section-title"><tkd-icon name="ruler"/> Вік і вага</h5>
        <div class="adm-form-grid">
          <div class="adm-field">
            <label class="adm-label" for="cat-age1">Вік від, років</label>
            <input id="cat-age1" class="adm-input" type="number" min="0" max="100" v-model="formAddCategory.age1" placeholder="0">
          </div>
          <div class="adm-field">
            <label class="adm-label" for="cat-age2">Вік до, років</label>
            <input id="cat-age2" class="adm-input" type="number" min="0" max="100" v-model="formAddCategory.age2" placeholder="100">
          </div>
          <div class="adm-field">
            <label class="adm-label" for="cat-weight1">Вага від, кг</label>
            <input id="cat-weight1" class="adm-input" type="number" min="0" max="200" v-model="formAddCategory.weight1" placeholder="0">
          </div>
          <div class="adm-field">
            <label class="adm-label" for="cat-weight2">Вага до, кг</label>
            <input id="cat-weight2" class="adm-input" type="number" min="0" max="200" v-model="formAddCategory.weight2" placeholder="200">
          </div>
        </div>
      </section>

      <section class="adm-section">
        <h5 class="adm-section-title"><tkd-icon name="settings"/> Тип і формат</h5>
        <div class="adm-form-grid">
          <div class="adm-field adm-span-2" :class="{ 'has-error': errors.type }">
            <label class="adm-label">Розділ <span class="adm-req">*</span></label>
            <div class="adm-choice" role="radiogroup" aria-label="Розділ">
              <button v-for="option in options.type" :key="option.id" type="button" role="radio"
                      :aria-checked="isChosen(formAddCategory.type, option.id) ? 'true' : 'false'"
                      :class="{ active: isChosen(formAddCategory.type, option.id) }"
                      @click="choose('type', option)">{{ option.name }}</button>
            </div>
            <div class="adm-field-error" v-if="errors.type">{{ errors.type }}</div>
          </div>

          <div class="adm-field adm-span-2" :class="{ 'has-error': errors.showType }">
            <label class="adm-label">Формат <span class="adm-req">*</span></label>
            <div class="adm-choice" role="radiogroup" aria-label="Формат">
              <button v-for="option in options.showType" :key="option.id" type="button" role="radio"
                      :aria-checked="isChosen(formAddCategory.showType, option.id) ? 'true' : 'false'"
                      :class="{ active: isChosen(formAddCategory.showType, option.id) }"
                      @click="choose('showType', option)">{{ option.name }}</button>
            </div>
            <div class="adm-field-error" v-if="errors.showType">{{ errors.showType }}</div>
          </div>

          <div class="adm-field adm-span-2" v-if="isPoomsae" :class="{ 'has-error': errors.poomsaeType }">
            <label class="adm-label">Вид пумсе <span class="adm-req">*</span></label>
            <div class="adm-choice" role="radiogroup" aria-label="Вид пумсе">
              <button v-for="option in options.poomsaeType" :key="option.id" type="button" role="radio"
                      :aria-checked="isChosen(formAddCategory.poomsaeType, option.id) ? 'true' : 'false'"
                      :class="{ active: isChosen(formAddCategory.poomsaeType, option.id) }"
                      @click="choose('poomsaeType', option)">{{ option.name }}</button>
            </div>
            <div class="adm-field-error" v-if="errors.poomsaeType">{{ errors.poomsaeType }}</div>
          </div>

          <div class="adm-field adm-span-2">
            <label class="adm-label">Відділення</label>
            <v-select append-to-body label="name" :filterable="true" :options="sections"
                      placeholder="Оберіть відділення"
                      v-model="formAddCategory.section">
              <template slot="no-options">Відділень немає</template>
            </v-select>
          </div>
        </div>
      </section>
    </div>

    <div class="adm-form-foot">
      <span class="adm-form-summary" v-if="errorCount">Заповніть обовʼязкові поля ({{ errorCount }})</span>
      <div class="adm-form-foot-actions">
        <button type="button" class="adm-btn" @click="saveCategoryClose()">Скасувати</button>
        <button type="button" class="adm-btn adm-btn-primary" @click="saveCategoryAndAdd()"><tkd-icon name="save"/> Зберегти</button>
      </div>
    </div>
  </div>
</template>

<script>
  import 'src/assets/css/tkd-theme.css';
  import 'src/assets/css/tkd-admin.css';

  export default {
    name: "form-category",
    props: ['formAddCategory'],

    data() {
      return {
        errors: {},
        // ті самі значення {id, name}, що були у v-select
        options: {
          sex: [{id:0, name:'-'}, {id:1, name:'чоловік'}, {id:2, name:'жінка'}],
          status: [{id:1, name:'Опубліковано'}, {id:2, name:'Чернетка'}],
          type: [{id:1, name:'Керугі'}, {id:2, name:'Пумсе'}],
          showType: [{id:1, name:'Сітка'}, {id:2, name:'Список'}],
          poomsaeType: [{id:1, name:'Традиційне'}, {id:2, name:'Вільне (фрістайл)'}],
        },
      }
    },


    computed: {
      tournamentOne() {
        return this.$store.getters['tournament/tournamentOne'];
      },
      actionTournamentAddCategory() {
        return this.$store.getters['settings/actionTournamentAddCategory'];
      },
      item() {
        return this.tournamentOne.data && this.tournamentOne.data.item ? this.tournamentOne.data.item : null;
      },
      sections() {
        return this.item && this.item.sections ? this.item.sections : [];
      },
      isPoomsae() {
        return this.isChosen(this.formAddCategory.type, 2);
      },
      ageCategorySuggestions() {
        let protocols = this.item && this.item.protocols ? this.item.protocols : [];
        return [...new Set(protocols.map(protocol => protocol.age_category).filter(Boolean))].sort();
      },
      errorCount() {
        return Object.keys(this.errors).length;
      },
    },

    watch: {
      // нове відкриття форми — скидаємо помилки
      'formAddCategory.id'() {
        this.errors = {};
      },
      actionTournamentAddCategory() {
        this.errors = {};
      },
    },

    methods:{
      // значення може бути об'єктом {id, name} з форми або сирим id з сервера
      isChosen(value, id) {
        if (value === '' || value === null || value === undefined) return false;
        return value.id !== undefined ? value.id == id : value == id;
      },
      choose(field, option) {
        this.formAddCategory[field] = option;
        this.clearError(field);
      },
      clearError(field) {
        if (this.errors[field]) {
          this.$delete(this.errors, field);
        }
      },
      saveCategoryClose(){
        // this.actions.addCategory = false;
        this.$modal.hide('category-form-modal');
        // this.actions.addCategory = false;
      },
      saveCategoryAndAdd() {
        this.saveCategory(false);
      },

      saveCategoryAndClose() {
        this.saveCategory(true);
      },


      saveCategory(close) {
        var params = Object.assign({}, this.formAddCategory);
        params.tournament = this.tournamentOne.data.item.id;
        params.sex = params.sex.id == undefined ? 0: params.sex.id;
        params.type = params.type.id == undefined ? 0: params.type.id;
        params.poomsaeType = params.poomsaeType.id == undefined ? 0: params.poomsaeType.id;
        params.categoryStatus = params.categoryStatus.id == undefined ? 0: params.categoryStatus.id;
        params.showType = params.showType.id == undefined ? 0: params.showType.id;

        // ті самі перевірки, що й раніше, але з підсвіткою полів замість alert
        let errors = {};
        if((params.name || '').length < 1){
          errors.name = 'Вкажіть назву категорії';
        }
        if(params.type == 0){
          errors.type = 'Оберіть розділ — керугі чи пумсе';
        }
        if(params.showType < 1){
          errors.showType = 'Оберіть формат — сітка чи список';
        }
        // якщо це пумсе то треба указати яке
        if(params.type == 2 && params.poomsaeType < 1){
          errors.poomsaeType = 'Оберіть вид пумсе';
        }
        if(params.categoryStatus < 1){
          errors.categoryStatus = 'Оберіть статус категорії';
        }
        this.errors = errors;
        if (Object.keys(errors).length) {
          return false;
        }

        // если сначал была выбрано пумсе потом поменяли на керуги - скинуть данные о выбраном пумсе
        if(params.type == 1){
          params.poomsaeType = 0;
        }

        if (params.id != undefined) {
          this.$store.dispatch('tournament/addCategory', params)
            .then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id}))
            .catch(error => {
              this.$notify({ text: 'Помилка збереження', type: 'error' });
            });

          // TODO добавить обработку ошибок

        } else {

          // .then(() => this.successfulSaved())
          // .catch(error => {
          //   this.faileSaved()
          // });
        }

        // this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id});
        this.$modal.hide('category-form-modal');
      },

    }
  }
</script>

<style scoped>
  /* поле пошуку v-select без рамки lbd */
  .adm-field >>> .vs__search { border: 0; }
</style>
